import isBEV from "../../functions/vehicle/isBEV";
import isPHEV from "../../functions/vehicle/isPHEV";
import {
  GASOLINE_PRICE_IN_DOLLARS_PER_GAL,
  ELECTRICITY_RATE_IN_DOLLARS_PER_KWH
} from "../../client_customizations/data/assumptions/ASSUMPTIONS"

const calcElectricRangeForBudget = (kwhPerHundredMiles, budget) => {
  if (kwhPerHundredMiles === 0) return 0;

  return (
    budget *
    (1 / ELECTRICITY_RATE_IN_DOLLARS_PER_KWH.value) *
    (100 / kwhPerHundredMiles)
  );
};

const calcGasolineRangeForBudget = (mpg, budget) => {
  return budget * (1 / GASOLINE_PRICE_IN_DOLLARS_PER_GAL.value) * mpg;
};

const calcVehicleRangeForBudget = (
  vehicle,
  budget,
  electricMilesPortionForPhev
) => {
  if (isBEV(vehicle)) {
    return calcElectricRangeForBudget(vehicle.electric_efficiency, budget);
  }

  if (isPHEV(vehicle)) {
    return (
      (electricMilesPortionForPhev / 100) *
        calcElectricRangeForBudget(vehicle.electric_efficiency, budget) +
      (1 - electricMilesPortionForPhev / 100) *
        calcGasolineRangeForBudget(vehicle.fossil_fuel_efficiency, budget)
    );
  }

  return calcGasolineRangeForBudget(vehicle.fossil_fuel_efficiency, budget);
};

export default calcVehicleRangeForBudget;
